module.exports = __webpack_public_path__ + "static/media/ts15cr93.3e4c2093.png";